import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbCftv } from 'app/abstract/full-pages/cftv/cftv.abstract';
import { AppFilter } from 'app/models/app-filter.model';
import { Cftv } from 'app/models/cftv.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CftvService extends AbCftv {

  public prefixo = 'cftv/';

  constructor(http: HttpClient) {
    super(http);
  }

  public salvar(cftv: Cftv): Observable<any> {
    return this.save(`${this.prefixo}`, cftv);
  }

  public getAllCftvs(filter: AppFilter): Observable<any> {
    return this.get(`${this.prefixo}filter/${filter.encode()}`);
  }


  public getCftvId(id: number): Observable<any> {
    return this.get(`${this.prefixo}${id}`);
  }

  public desativar(id: number) {
    return this.delete(`${this.prefixo}`, id);
  }


  public getAllFabricantesAtivos() {
    return this.get('fabricantes/cftv/ativos/'); 
  }


  public getAllModelosPorFabricante(fabricanteId: number) {
    return this.get(`modelos/fabricante/${fabricanteId}`);
  }


  public testeConexao(cftv: Cftv) {
    return this.http.post(this.url + `${this.prefixo}testeConexao`, cftv, { responseType: 'text' });
  }

}